export { inboxitemCreateCommand } from './v1/inboxitem_create';
export { inboxappCreateCommand } from './v1/inboxapp_create';

import { inboxitemCreateCommand } from './v1/inboxitem_create';
import { inboxappCreateCommand } from './v1/inboxapp_create';

export const inboxCommands = [inboxitemCreateCommand, inboxappCreateCommand];
